// oxlint-disable rules/no-dynamic-import
// oxlint-disable-next-line import/no-unassigned-import
import "@/assets/styles.css";

const appType = import.meta.env.VITE_APP_TYPE;

if (appType === "web") {
  import("./index");
} else {
  // The desktop renderer is built by the Electron toolchain and is excluded
  // from the web typecheck, so it is referenced via a dynamic path.
  const desktopRenderer = "./app/renderer";
  import(/* @vite-ignore */ desktopRenderer);
}
